import { Contact } from '../../../../../common/src/entities';
import { CopierPressePapier } from './CopierPressePapier';
import PopoverSimple from '../../Common/PopoverSimple';
import { BiAt, BiPhone } from 'react-icons/all';
import React, { ReactElement } from 'react';

export function CelluleContact({ value }: { value: Contact }): ReactElement | null {
    const affichageTel = (
        <CopierPressePapier texte={value?.telephone}>
            <PopoverSimple inList texte={value?.telephone} titre="Téléphone">
                <BiPhone role="button" />
            </PopoverSimple>
        </CopierPressePapier>
    );
    const affichageEmail = (
        <CopierPressePapier texte={value?.email}>
            <PopoverSimple inList texte={value?.email} titre="Courriel">
                <BiAt role="button" />
            </PopoverSimple>
        </CopierPressePapier>
    );
    return value ? (
        <div className="d-flex">
            <span className="flex-grow-1">{value.name}</span>
            <span>
                {value.telephone ? <>{affichageTel} </> : null}
                {value.email ? <>{affichageEmail} </> : null}
            </span>
        </div>
    ) : null;
}
